/**
 * internal dependencies
 */
import CognitoLogOutUser from '../auth/cognito-logout-user';

/**
 * Logs out the user from Cognito
 * 
 * @returns void
 */
const LogOutUser = async () => {
  await CognitoLogOutUser();
  localStorage.removeItem('persist:root');

  sessionStorage.removeItem('cognitoIdToken');
  sessionStorage.removeItem('cognitoAccessToken');
  sessionStorage.removeItem('cognitoRefreshToken');
}

export default LogOutUser; 